<template>
    <div>
        <project-navbar
            :hide-login="$route.meta.hideLogin"
            @information="showResumeModal = true"
            @share="showShareModal = true"
        />
        <div :style="projectBackgroundStyle" class="is-clipped lb-full-height">
            <slot @share="showShareModal = true"></slot>
        </div>
        <project-modal-resume
            v-if="showResumeModal"
            :show-navigation-buttons="false"
            :project-source="$store.getters.project"
            @share="showShareModal = true"
            @close="showResumeModal = false"
        />
        <project-modal-share
            v-if="showShareModal"
            :content="$store.getters.project"
            @close="showShareModal = false"
        ></project-modal-share>
    </div>
</template>

<script>
import ProjectNavbar from '@/components/ProjectNavbar';
import ProjectModalResume from '@/components/ProjectModalResume';
import ProjectModalShare from '@/components/ProjectModalShare';
import { projectBackground } from '@/lib/helpers';
import _ from 'underscore';
export default {
    components: {
        ProjectNavbar,
        ProjectModalResume,
        ProjectModalShare,
    },
    data() {
        return {
            showResumeModal: false,
            showShareModal: false,
        };
    },
    computed: {
        projectBackgroundStyle() {
            const bg = this.$store.getters.projectBackground;
            const bgImage = this.$store.getters.projectBackgroundImage;
            return projectBackground(_.isEmpty(bgImage) ? bg : bgImage);
        },
    },
    methods: {},
};
</script>

<style></style>
